// Letterheist's pieces (Jack, 2026-10-26, his pick B of three mockups): a
// short chess queen, a smooth dome inside a low flared coronet, in the tile
// colours: yellow for you, blue for your opponent. No flags and no piece to
// pick; these replace the heist crew portraits, which replaced the raiders.
import { VIEWBOX } from "@/lib/avatar2d";

const COLOURS = {
  y: { fill: "#f7c948", dark: "#a8791a", light: "#fff3c4" },
  b: { fill: "#3b7dc4", dark: "#1f4f86", light: "#bcd8f5" },
};

// Your look and your opponent's, as Game.jsx hands them to the board.
export const LH_ME_LOOK = { queen: "y" };
export const LH_OPP_LOOK = { queen: "b" };

// The queen in a 100 x 120 box, standing on y 116.
function queen(side) {
  const c = COLOURS[side] || COLOURS.y;
  const s = `fill="${c.fill}" stroke="${c.dark}" stroke-width="2.5" stroke-linejoin="round"`;
  return `<ellipse cx="50" cy="116" rx="36" ry="5" fill="rgba(0,0,0,.18)"/>`
    + `<path d="M16 112 Q16 101 27 99 L73 99 Q84 101 84 112 Z" ${s}/>`
    + `<path d="M24 99 Q24 91 33 90 L67 90 Q76 91 76 99 Z" ${s}/>`
    + `<path d="M33 90 Q37 76 39 66 L61 66 Q63 76 67 90 Z" ${s}/>`
    + `<path d="M38 87 Q41 76 43 68 L47 68 Q45 76 43 87 Z" fill="${c.light}" opacity=".55"/>`
    + `<rect x="31" y="61" width="38" height="7" rx="3.5" ${s}/>`
    + `<path d="M36 52 Q36 34 50 33 Q64 34 64 52 Z" ${s}/>`
    + `<path d="M41 46 Q42 38 48 37" fill="none" stroke="${c.light}" stroke-width="2.5" stroke-linecap="round" opacity=".7"/>`
    + `<path d="M33 61 L27 45 Q33.5 50 40 45 Q45 50 50 45 Q55 50 60 45 Q66.5 50 73 45 L67 61 Z" ${s}/>`;
}

// For the start screen and the Games menu.
export function queenCard(side) {
  return `<svg viewBox="10 22 80 100" xmlns="http://www.w3.org/2000/svg">${queen(side)}</svg>`;
}

// How big the queen stands on the board, against the size she was first
// drawn at (Jack, 2026-10-26: smaller pieces).
export const LH_QUEEN_SIZE = 0.75;

// For the board, in the raiders' drawing box (avatar2d VIEWBOX), standing on
// the same feet point, so jangle.html places and walks it like a raider. The
// board fits a piece to its drawn extent, so an unseen box the full queen's
// size keeps her slot, and she is drawn smaller inside it, feet in place.
export function renderQueen(side, size = LH_QUEEN_SIZE) {
  const vb = VIEWBOX, k = 1.6 * size;
  return `<svg viewBox="${vb.x} ${vb.y} ${vb.w} ${vb.h}" xmlns="http://www.w3.org/2000/svg" class="jav lh-queen">`
    + `<rect x="${20 + 14 * 1.6}" y="${42.4 + 31 * 1.6}" width="${72 * 1.6}" height="${90 * 1.6}" fill="none"/>`
    + `<g transform="translate(${100 - 50 * k} ${228 - 116 * k}) scale(${k})">${queen(side)}</g></svg>`;
}
